import { useMutation } from "@tanstack/react-query";
import { getMe, sendToken, useCsrfToken } from "client/actions/users";
import Loader from "client/components/Loader";
import { setCurrentUser, useAuthDispatch, useAuthState } from "client/context";
import useSearchParams from "client/hooks/useSearchParams";
import { Heading, Text } from "client/ui-components";
import UserPageLayout from "client/ui-components/Layouts/UserPage";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Content, Wrapper } from "./styles";

const ERRORS = {
  INVALID: "INVALID",
};

export default function MagicLink() {
  const [search] = useSearchParams();
  const history = useHistory();
  const { user } = useAuthState();
  const [useCsrf] = useCsrfToken();

  const tokenIsMissing = !search.get("token");

  const dispatch = useAuthDispatch();
  const { mutate, error } = useMutation({
    mutationFn: async (token: string) => {
      await useCsrf();
      const res = await sendToken({ token });
      if (!res?.success) throw new Error(ERRORS.INVALID);
      const user = await getMe();
      return user;
    },
    onSuccess: user => {
      setCurrentUser(dispatch, user);
    },
  });

  useEffect(() => {
    const token = search.get("token");
    if (!token) return history.push("/");
    mutate(token);
  }, []);

  useEffect(() => {
    if (!user.id) return;
    const redirectTo = search.get("redirectTo") ?? "/";
    history.push(redirectTo);
  }, [user]);

  if (tokenIsMissing) {
    return null;
  }

  return (
    <UserPageLayout>
      <Wrapper className="px-35">
        <Content>
          {error ? (
            <>
              <Heading variant="h2" as="h1" textAlign="center" className="mb-25">
                This Link Has Expired
              </Heading>
              <Text textAlign="center" fontWeight={400}>
                For your security, this link is no longer valid. Please go to a new browser (not
                your native email browser) and sign in to your account.
              </Text>
            </>
          ) : (
            <Loader />
          )}
        </Content>
      </Wrapper>
    </UserPageLayout>
  );
}
